import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f7a248"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "OBCテナント選択", -1))
const _hoisted_2 = {
  id: "select-tenant-form",
  class: "card"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-tenant" }, "テナント", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_6 = ["value", "textContent"]
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "mt-3 text-right" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.initializing }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "card-body",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              id: "select-tenant",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.tenantId) = $event))
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenants, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.tenantId,
                  value: t.tenantId,
                  textContent: _toDisplayString(t.tenantName)
                }, null, 8, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.values.tenantId]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_response_result_alert, {
              "is-succeed": _ctx.isRequestSucceed,
              "error-message": _ctx.requestErrorMessage,
              onDismiss: _ctx.dismissAlert
            }, null, 8, ["is-succeed", "error-message", "onDismiss"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: !_ctx.meta.valid,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickedRegister && _ctx.onClickedRegister(...args)))
            }, "登録", 8, _hoisted_9)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}